import React, { useContext, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { FormControl, FormControlLabel } from "@mui/material";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";

function SettingsProjectsStatusEmailConfiguration(props) {
  const creds = useContext(CredsContext).creds;

  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const emailSettings = projectObject.oada_status_email_config__c;
  let currentSettings = [];
  if (emailSettings) {
    currentSettings = emailSettings.split(":|:");
  } else {
    for (let i = 0; i < 3; i++) {
      currentSettings.push("");
    }
  }

  const handleTextFieldValueChange = (event) => {
    //console.log(event.target.value);
  };

  const handleTextFieldBlur = (event) => {
    if (event.target.id == "___statusReportEmailSubject") {
      currentSettings[0] = event.target.value;
    } else if (event.target.id == "___statusReportEmailMessage") {
      currentSettings[1] = event.target.value;
    } else if (event.target.id == "___statusReportEmailReplyTo") {
      currentSettings[2] = event.target.value;
    }
    const newSetting = currentSettings.join(":|:");
    projectObject.oada_status_email_config__c = newSetting;
    sessionStorage.setItem("projectObject", JSON.stringify(projectObject));

    const authString = Tools.getXmlBodyAuthString(creds);
    const urlString = Tools.getInstanceUrl(creds);
    const requestString =
      authString +
      '<Modify type="Project" enable_custom="1"><Project><id>' +
      projectObject.id +
      "</id><oada_status_email_config__c>" +
      newSetting +
      "</oada_status_email_config__c></Project></Modify></request>";
    Tools.fetchPost(requestString, urlString);
  };

  const formControlLabelStyle = {
    "& .MuiFormControlLabel-label": {
      width: 125,
      color: "white",
      textAlign: "right",
    },
  };
  return (
    <Box>
      <Typography sx={{ color: "white", paddingLeft: "15px" }}>
        Configuration for Status Report email:
      </Typography>
      <FormControl>
        <FormControlLabel
          labelPlacement="start"
          control={
            <TextField
              //required
              id="___statusReportEmailSubject"
              //onChange={handleTextFieldValueChange}
              onBlur={handleTextFieldBlur}
              variant="standard"
              defaultValue={currentSettings[0]}
              //label="Subject"
              sx={{
                margin: "5px 10px",
                width: "350px",
                verticalAlign: "middle",
                backgroundColor: "white",
                borderRadius: "10px",
                paddingLeft: "10px",
              }}
            ></TextField>
          }
          sx={{ ...formControlLabelStyle }}
          label="Subject: "
        />
        <FormControlLabel
          labelPlacement="start"
          control={
            <TextField
              multiline
              minRows={4}
              id="___statusReportEmailMessage"
              //onChange={handleTextFieldValueChange}
              onBlur={handleTextFieldBlur}
              variant="standard"
              defaultValue={currentSettings[1]}
              //label="Subject"
              sx={{
                margin: "5px 10px",
                width: "350px",
                verticalAlign: "middle",
                backgroundColor: "white",
                borderRadius: "10px",
                paddingLeft: "10px",
              }}
            ></TextField>
          }
          sx={{ ...formControlLabelStyle }}
          label="Message: "
        />
        <FormControlLabel
          labelPlacement="start"
          control={
            <TextField
              //required
              id="___statusReportEmailReplyTo"
              //onChange={handleTextFieldValueChange}
              onBlur={handleTextFieldBlur}
              variant="standard"
              defaultValue={currentSettings[2]}
              //label="Subject"
              sx={{
                margin: "5px 10px",
                width: "350px",
                verticalAlign: "middle",
                backgroundColor: "white",
                borderRadius: "10px",
                paddingLeft: "10px",
              }}
            ></TextField>
          }
          sx={{ ...formControlLabelStyle }}
          label="Reply to email: "
        />
      </FormControl>
    </Box>
  );
}

export default SettingsProjectsStatusEmailConfiguration;

SettingsProjectsStatusEmailConfiguration.propTypes = {};
